module.exports = __webpack_public_path__ + "img/ipad_splash.e16a9ffc.png";